import React from "react";
import { Container, ContentWrapper, TitleBig, TitleSmall, Img404, BackButton } from "./styles";
import { Icon } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const NotFound: React.FC = () => {
  const history = useHistory();

  const handleGoBack = () => {
    history.push("/home");
  };

  return (
    <Container>
      <ContentWrapper>
        <TitleBig>Página não encontrada</TitleBig>
        <TitleSmall>
          A página que você está tentando acessar não existe ou ainda não foi implementada.
        </TitleSmall>
        <Img404 src="/img/404.svg" alt="404" />
        <BackButton onClick={handleGoBack}>
          <Icon>home</Icon>
          <span>Voltar para Home</span>
        </BackButton>
      </ContentWrapper>
    </Container>
  );
};

export default NotFound;
